import React, { useEffect, useRef, useState } from 'react'
import { OnlineCourseApi } from '../../../api/cms-online-course/online_course.api';
import { useParams } from 'react-router-dom';
import NavigateListCustom from '../../../components/navigation/NavigationListCustom';
import { routeName } from '../../../routes/routeName';
import { PublishOnlineCourseApi } from '../../../api/publish-online-course/publish-online-course.api';
import { Box, Button, Grid, Step, StepContent, StepLabel, Stepper, Tab, Tabs, Typography } from '@mui/material';
import FormLesson from './step/form';
import { DocumentLesson, TerminologyLesson } from './take-lesson';
import ReactPlayer from 'react-player'

export default function ExampleCourse() {

  const { id } = useParams()
  const [value, setValue] = useState(0);
  const [activeMainStep, setActiveMainStep] = useState(0);
  const [activeSubStep, setActiveSubStep] = useState(0);
  const videoRef = useRef<any>(null);
  const [progress, setProgress] = useState(0);
  // const [configForm, setconfigForm] = useState<any[]>([]);
  const [lessonData, setLessonData] = useState<any[]>([]);
  // const [steps, setSteps] = useState<any[]>([]);
  // const [detail, setDetail] = useState<any>()
  const [basicInfo, setBasicInfo] = useState<any>()
  // const [form, setForm] = useState<any>()
  // const [items, setItems] = useState<any[]>([])
  // const [selectedIndex, setSelectedIndex] = useState<number>(0);
  // const [id_online_course_config_form, set_id_online_course_config_form] = useState<number>(0);
  // const [id_online_course_lesson, set_id_online_course_lesson] = useState<number>(0);
  // const [id_online_course_study_topics, set_id_online_course_study_topics] = useState<number>(0);
  const [file, set_file] = useState<any>();
  const getLessonTopicData = async (id_online_course_lesson: any, id_online_course_study_topics: any) => {
    set_file(null)
    const res = await OnlineCourseApi.getLessonTopic(id, id_online_course_lesson, id_online_course_study_topics);
    const data = res.data
    set_file(data?.data);


  }
  // const transformConfigToSteps = (configItems: any, lessonItems: any) => {
  //   return [
  //     ...lessonItems,
  //   ];
  // };
  // const loadConfigForms = async () => {
  //   const res = await OnlineCourseApi.getconfigForm({}, id);
  //   return res.data?.data?.items ?? [];
  // };
  // const loadConfigFormContent = async (id_config_form: any) => {
  //   const res = await OnlineCourseApi.getconfigFormById(id, id_config_form);
  //   const formId = res.data?.data?.id_online_course_form;

  //   if (formId) await loadFormById(formId);
  // };

  const loadCourseDetailAndForm = async (steps?: any, step?: number, subStep?: any) => {
    const res = await PublishOnlineCourseApi.id(id);

    if (res.status < 300) {
      const info = res.data.data;

      // setDetail(info);
      setBasicInfo(info?.basic_info?.data);

      // const selectedChildren = steps[step || activeMainStep]?.children[subStep]
      // const selected = steps[step || activeMainStep]
      // if (selectedChildren?.id || selected?.id) {
      //   set_id_online_course_config_form(selectedChildren?.id || selected.id);
      //   await loadConfigFormContent(selectedChildren?.id || selected.id);
      // }
      // if (selectedChildren?.id_online_course_study_topics || selected?.id_online_course_study_topics) {
      //   await getLessonTopicData(selectedChildren?.id_online_course_lesson || selected?.id_online_course_lesson, selectedChildren?.id_online_course_study_topics || selected?.id_online_course_study_topics)
      // }
    }
  };

  // const loadFormById = async (formId: any) => {
  //   const res = await OnlineCourseApi.getFormById(formId);
  //   const data = res.data;

  //   // flatten choices
  //   const merged = data.course_form_subject
  //     .flatMap((group: any) =>
  //       group.choices.map((choice: any) => ({
  //         ...choice,
  //         online_course_form_choice_type: group.online_course_form_subject_type,
  //         online_course_form_subject_point: group.online_course_form_subject_point,
  //         online_course_form_choice_point: group.online_course_form_subject_point,
  //       }))
  //     )
  //     .map((item: any, index: number) => ({ ...item, index }));

  //   setItems(merged);
  //   setForm(data);
  // };

  const getVideoDuration = async (
    id_online_course_lesson?: any,
    id_online_course_study_topics?: any
  ): Promise<number> => {
    try {
      const res = await OnlineCourseApi.getLessonTopic(id, id_online_course_lesson, id_online_course_study_topics);
      const file = res.data.data?.online_course_study_topics_file;
      if (!file) return 0;

      // ใส่ / คั่น และกันกรณี file_path ลงท้ายด้วย / อยู่แล้ว
      const url = `${process.env.REACT_APP_FILE_BASE_API}/${file.file_path}/${file.file_name}`.replace(/([^:])\/{2,}/g, '$1/');

      return await new Promise<number>((resolve, reject) => {
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.onloadedmetadata = () => resolve(video.duration);
        video.onerror = () => reject(new Error(`โหลดวิดีโอไม่สำเร็จ: ${url}`));
        video.src = url;
      });
    } catch (err) {
      console.error(err);
      return 0; // ไม่ให้ error หลุดไปพังทั้ง tree
    }
  };
  const formatDuration = (seconds: number): string => {
    if (!seconds || isNaN(seconds)) return '00:00:00';

    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = Math.floor(seconds % 60);

    const pad = (n: number) => String(n).padStart(2, '0');

    return `${pad(h)}:${pad(m)}:${pad(s)}`;
  };

  const loadLessonTree = async () => {
    const res = await OnlineCourseApi.listLesson(id);
    const lessons = res.data?.data ?? [];
    const mapped = await Promise.all(
      lessons.map(async (lesson: any) => {
        const topicRes = await OnlineCourseApi.listLessonTopic(id, lesson.id_online_course_lesson);
        const topics = topicRes?.data?.data ?? [];
        return {
          label: lesson.online_course_lesson_name,
          children: await Promise.all(
            topics
              .filter((x: any) => x?.mark_as_example)
              .map(async (t: any) => {
                const time = await getVideoDuration(
                  t?.id_online_course_lesson,
                  t?.id_online_course_study_topics
                );
                return {
                  label: t.online_course_study_topics_name,
                  id_online_course_study_topics: t?.id_online_course_study_topics,
                  id_online_course_lesson: t?.id_online_course_lesson,
                  time: formatDuration(time), // ตอนนี้เป็น number (วินาที) แล้ว
                };
              })
          ),
        };
      })
    );
    setLessonData(mapped);
    let id_online_course_lesson = mapped.filter((items: any) => items?.children?.length > 0)?.length > 0 ? mapped.filter((items: any) => items?.children?.length > 0)[0]?.children[0]?.id_online_course_lesson : undefined
    let id_online_course_study_topics = mapped.filter((items: any) => items?.children?.length > 0)?.length > 0 ? mapped.filter((items: any) => items?.children?.length > 0)[0]?.children[0]?.id_online_course_study_topics : undefined
    // set_id_online_course_lesson(id_online_course_lesson)
    // set_id_online_course_study_topics(id_online_course_study_topics)
    if (id_online_course_lesson && id_online_course_study_topics) {
      await getLessonTopicData(id_online_course_lesson, id_online_course_study_topics);
    }

    return mapped;
  };

  // useEffect(() => {
  //   console.log(id_online_course_lesson, id_online_course_study_topics);
  //   if (id_online_course_lesson && id_online_course_study_topics) {
  //     getLessonTopicData(id_online_course_lesson, id_online_course_study_topics);
  //   }
  // }, [id_online_course_lesson, id_online_course_study_topics])

  // const loadFormAnswers = async () => {
  //   const res = await PublishOnlineCourseApi.form_answer(id);
  //   // console.log("Form Answers:", res.data?.data);
  //   console.log(steps, res.data?.data);

  // };
  useEffect(() => {
    const init = async () => {
      // 1) load config
      // const configItems = await loadConfigForms();
      // setconfigForm(configItems);

      // 2) load lessons using config
      await loadLessonTree();

      // 3) merge steps: QUIZ_BEFORE → lessons → QUIZ_AFTER → Survey
      // const steps = transformConfigToSteps(configItems, lessonTree);
      // setSteps(steps);

      // 4) load detail + load form choice of active step
      await loadCourseDetailAndForm();

      // 5) load answers
      // await loadFormAnswers();
    };

    init();
  }, []);

  const handleHTML5TimeUpdate = () => {
    const video = videoRef.current;
    if (video) {
      const current = video.currentTime;
      const total = video.duration;
      if (total > 0) {
        setProgress((current / total) * 100);
      }
    }
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  // console.log(steps);

  // console.log(file?.online_course_study_topics_file && getVideoDuration(`${process.env.REACT_APP_FILE_BASE_API }/${ file?.online_course_study_topics_file?.file_path }${file?.online_course_study_topics_file?.file_name }`));

  return (
    <div className="h-auto">
      <NavigateListCustom
        navigateData={[
          {
            name: "ระบบคอร์สออนไลน์",
            key: "1",
            pathName: routeName.students.OnlineCourse,
          },
          {
            name: "คอร์สทั้งหมด ",
            key: "2",
            pathName: routeName.students.ListOnlineCourse,
          },
          {
            name: `${basicInfo?.online_course_no} ${basicInfo?.online_course_name}`,
            key: "3",
            pathName: routeName.students.OnlineCourseDetail.replace(':id', `${id}`),
          },
        ]}
      />
      <section className="my-4">
        <Typography variant="h3">(ตัวอย่าง) {basicInfo?.online_course_no} {basicInfo?.online_course_name}</Typography>
      </section>
      <section className="my-4">
        <Grid container spacing={2}>
          <Grid item lg={7}>
            <div style={{
              boxShadow: '0px 0px 8.8px 0px #00000026',
              padding: '40px',
              borderRadius: '16px',
              display: 'flex',
              flexDirection: 'column',
              gap: '20px',
              marginBottom: '20px'
            }}>
              {/* {!isFinished ? ( */}
              <>
                {
                  // !file ? form && <FormLesson form={form} items={items} setItems={setItems} selectedIndex={selectedIndex} setSelectedIndex={setSelectedIndex} /> :
                  file?.online_course_study_topics_file ?
                    <>
                      <video
                        ref={videoRef}
                        width="100%"
                        // height={'500px'}
                        controls
                        onTimeUpdate={handleHTML5TimeUpdate}
                      >
                        <source src={`${process.env.REACT_APP_FILE_BASE_API}/${file?.online_course_study_topics_file?.file_path}${file?.online_course_study_topics_file?.file_name}`} type="video/mp4" />
                        Your browser does not support HTML5 video.
                      </video>
                    </>
                    :
                    <ReactPlayer
                      src={file?.online_course_study_topics_link}
                      controls
                      width="100%"
                      height="457px"
                      onProgress={(state: any) => console.log(state.playedSeconds)}
                    />}
                {/* {(lessonData.filter((items: any) => items?.children?.length > 0)?.length) !== activeMainStep && <Button
                  variant="contained"
                  size="small"
                  onClick={handleNext}
                  // disabled={(activeSubStep === 1 && progress !== 100)}
                  sx={{ mr: 1 }}
                >
                  ถัดไป
                </Button>} */}


              </>

            </div>
          </Grid>
          <Grid item lg={5}>
            <div style={{
              boxShadow: '0px 0px 8.8px 0px #00000026',
              // padding: '40px',
              borderRadius: '16px',
              display: 'flex',
              flexDirection: 'column',
              gap: '20px',
              marginBottom: '20px'
            }}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" sx={{
                  '& .MuiTabs-indicator': {
                    backgroundColor: "#F79009"
                  }
                }}>
                  <Tab label="เนื้อหา" sx={{
                    '&.Mui-selected': {
                      color: '#F79009',
                    }
                  }} />
                  <Tab label="เอกสาร" sx={{
                    '&.Mui-selected': {
                      color: '#F79009',
                    }
                  }} />
                  <Tab label="คำศัพท์" sx={{
                    '&.Mui-selected': {
                      color: '#F79009',
                    }
                  }} />
                </Tabs>
              </Box>
              {value === 0 &&
                <div style={{ padding: '20px 40px', }}>
                  <Box sx={{ maxWidth: 600 }}>
                    {/* <Typography variant="h6">(ตัวอย่าง) {basicInfo?.online_course_no} {basicInfo?.online_course_name}</Typography> */}
                    <Stepper activeStep={activeMainStep} orientation="vertical" nonLinear sx={{
                      // border: '0px'
                      '& > .MuiStepConnector-root': {
                        display: 'none',
                      },
                    }}>
                      {lessonData.filter((items: any) => items?.children?.length > 0).map((step, index) => (
                        <Step key={index} expanded >
                          <StepLabel sx={{
                            '& .MuiStepLabel-iconContainer': {
                              display: 'none',
                            },
                          }}>
                            <Typography fontWeight="bold">(ตัวอย่าง) {step.label}</Typography>
                            <Typography sx={{ fontSize: '12px' }}>{lessonData.filter((items: any) => items?.children?.length > 0)[index]?.children?.length} หัวข้อการเรียน</Typography>
                          </StepLabel>
                          <StepContent sx={{ border: '0px', }}>
                            {step.children.length > 0 && lessonData.filter((items: any) => items?.children?.length > 0)[index]?.children === step.children ? (
                              <>
                                <Stepper activeStep={activeMainStep === index ? activeSubStep : 9999} orientation="vertical" nonLinear>
                                  {step.children.map((child: any, childIndex: number) => (
                                    <Step key={childIndex} sx={{ cursor: 'pointer' }} onClick={() => {
                                      setActiveSubStep(childIndex)
                                      setActiveMainStep(index)
                                      getLessonTopicData(child?.id_online_course_lesson, child?.id_online_course_study_topics)
                                    }} >
                                      <StepLabel sx={{
                                        '& .Mui-active': {
                                          color: '#F79009',
                                        },
                                        '& .MuiStepIcon-text': {
                                          display: 'none'
                                        },

                                      }}>
                                        <div style={{
                                          display: 'flex', justifyContent: "space-between"
                                        }}>
                                          <Typography>{child.label}</Typography>
                                          <Typography variant="caption" color="text.secondary">
                                           {child?.time}
                                          </Typography>
                                        </div>

                                      </StepLabel>
                                    </Step>
                                  ))}
                                </Stepper>
                              </>
                            ) : (
                              <Typography variant="body2" sx={{ mb: 2 }}>

                              </Typography>
                            )}

                          </StepContent>
                        </Step>
                      ))}
                    </Stepper>

                  </Box>

                </div>}
              {value === 1 && <DocumentLesson />
              }
              {value === 2 && <TerminologyLesson />
              }
            </div>
          </Grid>
        </Grid>
      </section>
    </div>
  )
}
